import { Column } from '../objects/column';
import { Preferences } from '../../profile/objects/preferences';
import { ListPreferenceResult, setListPreference } from '../../utils/list/utils/setListPreference';

export const DESTINATION_MODULE = 'DESTINATION';

export const DEFAULT_DESTINATION_COLUMNS: Column[] = [{
    label: 'name',
    field_name: 'NAME',
    checked: true,
    order_by: 'current_version__localization__name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'country',
    field_name: 'COUNTRY',
    checked: true,
    order_by: 'current_version__country__localization__name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'parent',
    field_name: 'PARENT',
    checked: true,
    order_by: 'parent__current_version__localization__name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'destination-type',
    field_name: 'TYPE',
    checked: true,
    order_by: 'current_version__type',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'picture',
    field_name: 'PICTURES',
    checked: true,
    order_by: '',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'online-to',
    field_name: 'VISIBILITY',
    checked: true,
    order_by: '',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'online-agency',
    field_name: 'AGENCY_VISIBILITY',
    checked: true,
    order_by: '',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: false,
    order_by: 'created_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: true,
    order_by: 'last_author__username',
    fixed_width: true,
    last_updated: false,
    width: null
}];

export const setDestinationPreference = (prefs: Preferences[], cols: Column[]): ListPreferenceResult =>
    setListPreference(prefs, cols, { module: DESTINATION_MODULE, default_columns: DEFAULT_DESTINATION_COLUMNS, default_order_by: 'current_version__localization__name', default_order: 'asc' });
